// Font scale — lets users bump the card text size up/down within a
// fixed set of steps (85% → 150%). Persisted in localStorage. Applied
// via the --font-scale CSS var which feeds .prompt / input font-size
// calcs (see styles/card.css + styles/forms.css).
//
// Wired by init(): call installFontScale() once on boot.

import { STORAGE_KEYS } from "../config/storage-keys";

export const FONT_STEPS: readonly number[] = [0.85, 0.9, 1, 1.1, 1.2, 1.35, 1.5];

export function loadFontScale(): number {
  const v = parseFloat(localStorage.getItem(STORAGE_KEYS.FONT_SCALE) || "");
  return FONT_STEPS.includes(v) ? v : 1;
}

function applyFontScale(scale: number): void {
  document.documentElement.style.setProperty("--font-scale", String(scale));
  const label = document.getElementById("fontSizeValue");
  if (label) label.textContent = Math.round(scale * 100) + "%";
}

export function changeFontScale(delta: number): void {
  const cur = loadFontScale();
  const idx = FONT_STEPS.indexOf(cur);
  const clamped = Math.max(0, Math.min(FONT_STEPS.length - 1, idx + delta));
  const next = FONT_STEPS[clamped]!;
  localStorage.setItem(STORAGE_KEYS.FONT_SCALE, String(next));
  applyFontScale(next);
}

/** Apply persisted scale + wire +/- buttons. Call once on boot. */
export function installFontScale(): void {
  applyFontScale(loadFontScale());
  document.getElementById("fontSizeUp")?.addEventListener("click", () => changeFontScale(1));
  document.getElementById("fontSizeDown")?.addEventListener("click", () => changeFontScale(-1));
}
